import { makeStyles } from '@material-ui/core';
import { compareAsc, parseISO } from 'date-fns';
import { DutyCodePeriod } from 'generated';

import { formatTime } from 'utils/date';

import { Box } from '@mui/material';

import { Period } from '../../../../admin-portal/Settings/DutyCodes/type';

interface Props {
  periods: Period[] | DutyCodePeriod[];
  periodId: string;
}

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    width: '95px',
    justifyContent: 'space-between'
  },
  periodTime: {
    width: '30px',
    textAlign: 'left'
  },
  dash: {
    width: '10px',
    textAlign: 'center'
  },
  description: {
    width: 150
  }
}));

export const sortByStartTime = (a, b) => {
  return compareAsc(parseISO(a.startTime), parseISO(b.startTime));
};

export const DutyCodePeriods = (props: Props) => {
  const { periods, periodId } = props;
  const classes = useStyles();
  return (
    <div>
      {periods.sort(sortByStartTime).map((period) => (
        <div key={period[periodId]}>
          <Box display="flex" gap={2.5} my={0.5}>
            <div className={classes.container}>
              <div className={classes.periodTime}>
                {formatTime(period.startTime)}
              </div>
              <div className={classes.dash}>-</div>
              <div className={classes.periodTime}>
                {formatTime(period.endTime)}
              </div>
            </div>
            <div className={classes.description}>
              {period.dutyHourType?.description}
            </div>
          </Box>
        </div>
      ))}
    </div>
  );
};
